import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Keyboard,
  LoadingController,
  NavController,
  NavParams
} from 'ionic-angular';
import {LoginPage} from "../login/login";
import {InitHelloPage} from "../init-hello/init-hello";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {StatusBar} from "@ionic-native/status-bar";
import {Subscription} from "rxjs";
import {InitPrescriptionPage} from "../init-prescription/init-prescription";

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
  @ViewChild(Content) public content: Content;

  loginPage: any = LoginPage;
  continuePage: any = InitPrescriptionPage;
  errorVisible: boolean = false;
  form : FormGroup;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider, public introWizard: IntroWizardServiceProvider, public authService: ApiAuthProvider, public loadingCtrl: LoadingController, private keyboard: Keyboard, public statusBar: StatusBar) {
    this.form = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.minLength(4), Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(4)]),
      terms: new FormControl('', [Validators.requiredTrue]),
      privacy: new FormControl('', [Validators.requiredTrue]),
    });
  }

  hideError() {
    this.errorVisible = false;
  }

  verifyData() {
    let me  = this;
    if(!this.form.valid) {
      this.errorVisible = true;
      return ;
    }

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.authService.register().then(res => {
      loading.dismiss();
      me.navCtrl.setRoot(me.continuePage)
    }, (err) => {
      console.log(err);
      loading.dismiss();
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent("Incorrect registration data title"),
        subTitle: this.contentTranslation.translateContent(err.errorMessage?err.errorMessage:"Incorrect registration data"),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
    })


  }

  showMoreInfo() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Form Modal Explain Title'),
      subTitle: this.contentTranslation.translateContent('Registration Form Modal Explain Text. \n'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();

  }

  showTerms(prefix) {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' title'),
      subTitle: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  keyboardShowCallback: Subscription;
  keyboardHideCallback: Subscription;
  ionViewDidLoad() {
    var me = this;

    this.keyboardShowCallback = this.keyboard.willShow.subscribe(function() {
      me.statusBar.hide();
    }, () => {}, () => {
      me.content.scrollToBottom();
    });
    this.keyboardHideCallback = this.keyboard.willHide.subscribe(function() {
      if((window as any).statusBarHiddenByDefault == false) {
        me.statusBar.show();
      }
    });
  }

  ionViewDidLeave() {
    this.keyboardShowCallback.unsubscribe();
    this.keyboardHideCallback.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts